import React from 'react';

var SvgWifiIcon = function SvgWifiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.72 7.79c-.293.293-.293.768 0 1.06.293.293.767.293 1.06 0 3.468-3.467 9.09-3.467 12.556 0 .293.293.768.293 1.061 0 .293-.292.293-.767 0-1.06-4.053-4.053-10.624-4.053-14.677 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.045 11.175c-.293-.293-.293-.768 0-1.06 2.769-2.77 7.258-2.77 10.027 0 .293.293.293.767 0 1.06-.293.293-.767.293-1.06 0-2.184-2.183-5.723-2.183-7.907 0-.293.293-.767.293-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.037 12.107c-.293.293-.293.768 0 1.06.293.294.768.294 1.061 0 1.083-1.082 2.838-1.082 3.921 0 .293.294.768.294 1.06 0 .294-.292.294-.767 0-1.06-1.668-1.668-4.373-1.668-6.042 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03 16.157c-.568-.568-.568-1.49 0-2.057.568-.568 1.49-.568 2.057 0 .568.568.568 1.489 0 2.057-.568.568-1.489.568-2.057 0Z"
  }));
};
SvgWifiIcon.displayName = "WifiIcon";

export { SvgWifiIcon as S };
